import { render, staticRenderFns } from "./AlertRow.vue?vue&type=template&id=0d06e744&scoped=true&"
import script from "./AlertRow.vue?vue&type=script&lang=ts&"
export * from "./AlertRow.vue?vue&type=script&lang=ts&"
import style0 from "./AlertRow.vue?vue&type=style&index=0&id=0d06e744&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06e744",
  null
  
)

export default component.exports